import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import Plx from "react-plx";
import { Container, Grid, Paper, Typography } from "@material-ui/core";

import useWindowDimensions from "../../../common/hooks/useWindowDimensions";

import { styles, item01Anim, item02Anim, item03Anim, item04Anim } from "./Features.styles";

function Features({ classes }) {
  const { height: viewHeight } = useWindowDimensions();
  return (
    <Container maxWidth="md" className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <Plx className={classes.paperItemPlx} parallaxData={item01Anim({ viewHeight })}>
                <Paper className={classes.paperItem}>
                  <img src="./gauge.png" className={classes.icon} alt="alt"/>
                  <Typography component="p" className={classes.description}>
                    <b>Monitorização e alertas</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Paper>
              </Plx>
            </Grid>
            <Grid item xs={3}>
              <Plx className={classes.paperItemPlx} parallaxData={item02Anim({ viewHeight })}>
                <Paper className={classes.paperItem}>
                  <img src="./automation.png" className={classes.icon} alt="alt" />
                  <Typography component="p" className={classes.description}>
                    <b>Automatização</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Paper>
              </Plx>
            </Grid>
            <Grid item xs={3}>
              <Plx className={classes.paperItemPlx} parallaxData={item03Anim({ viewHeight })}>
                <Paper className={classes.paperItem}>
                  <img src="./graph.jpg" className={classes.icon} alt="alt" />
                  <Typography component="p" className={classes.description}>
                    <b>Análise de dados</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Paper>
              </Plx>
            </Grid>
            <Grid item xs={3}>
              <Plx className={classes.paperItemPlx} parallaxData={item04Anim({ viewHeight })}>
                <Paper className={classes.paperItem}>
                  <img src="./internet.png" className={classes.icon} alt="alt" />
                  <Typography component="p" className={classes.description}>
                    <b>Acesso Remoto</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Paper>
              </Plx>
            </Grid>
          </Grid>
        </Container>
  );
}

export default withStyles(styles)(Features);
